import * as React from 'react';

import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import { CallHistoryMethodAction, push } from "connected-react-router";

import BackIcon from '@components/basics/icons/back';
import Typography from '@components/basics/typography';
import DashboardContainer from '@components/layout/dashboard-container';
import UserAgreement from '@components/statics/user-agreement';

interface AlphaPilotUserAgreementPageProps {
  className?: string;
  goHome: () => CallHistoryMethodAction;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goHome: () => dispatch(push('/')),
})

const AlphaPilotUserAgreementPage: React.FC<AlphaPilotUserAgreementPageProps> = (props) => (
  <DashboardContainer className={props.className}>
    <BackIcon
      className="mb-50"
      onClick={() => props.goHome()}
    />
    <Typography className="mb-30" type="subheader" weight="700">Alpha Pilot User Agreement</Typography>
    <UserAgreement />
  </DashboardContainer>
);

export default connect(null, mapDispatchToProps)(AlphaPilotUserAgreementPage);